import { FormTemplate } from "db/definitions";

export default function handleBuildFormTemplateBackupPath(formTemplate: FormTemplate): string {
	const formTemplateName = `${(formTemplate.templateName ?? formTemplate.template) + "-" + (formTemplate.versionName ?? null)}`;
	const url = `delete-template-backups/${formTemplateName}-${formTemplate.id}/${formTemplateName}.json`;
	return url;
}
